import { render, staticRenderFns } from "./WorkOrder.vue?vue&type=template&id=59ca42fc&"
import script from "./WorkOrder.vue?vue&type=script&lang=js&"
export * from "./WorkOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ca42fc')) {
      api.createRecord('59ca42fc', component.options)
    } else {
      api.reload('59ca42fc', component.options)
    }
    module.hot.accept("./WorkOrder.vue?vue&type=template&id=59ca42fc&", function () {
      api.rerender('59ca42fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/items/WorkOrder.vue"
export default component.exports